import React from 'react'
import ParcelDetailsByPin from '../parcels/components/ParcelDetailsByPin'


const DetailsByPinPanel: React.FC = () => {
  return (
    <aside id="sidebar">
      <section>
        <h3>Details</h3>
        <h4>Parcel</h4>
        <ParcelDetailsByPin />
      </section>
    </aside>
  )
}

export default DetailsByPinPanel